import { Amplify } from 'aws-amplify';

// *************************** Import CSS *************************** //

import "./nav-header-footer.css";

// ************************** Import Images ************************ //

//*** ASATTC Wordmark ***//
import "../assets/logos/asattc-wordmark-location-white.svg";

//*** ASATTC Logo ***//
import "../assets/logos/asattc-logo-blue.png";

//*** The Tycoon Group Alliance Photo ***//
import "../assets/logos/tycoon-group-alliance-logo.png";

//*** Social Icons ***//
import "../assets/social-icons/facebook.svg";
import "../assets/social-icons/instagram.svg";

// **************** Function Spinner Show & Hide ******************** //

  function spinnerShow() {
      document.getElementById("function-spinner").style.display = "block";
  }

  function spinnerHide() {
      document.getElementById("function-spinner").style.display = "none";
  }

// *************************************************** Insert Navigation Menu **************************************************** //

class FirstNav extends HTMLElement {
  connectedCallback() {
    this.innerHTML = `

    <div class="container">

      <nav id="navbar" class="navbar navbar-expand-xl fixed-top" aria-label="Navigation">

        <div class="container">

          <!-- ASATTC Wordmark -->

          <a class="navbar-brand" href="./index.html">
            <img src="asattc-wordmark-location-white.svg" height="100px" class="navbar-wordmark d-inline-block align-top mt-2" alt="A Seat At The Table Cafe wordmark" />
            <span class="hidden">A Seat At The Table Cafe</span>
          </a>

          <!-- Toggle Button for Mobile Nav -->

          <button class="navbar-toggler collapsed d-flex d-xl-none flex-column justify-content-around"
            type="button" data-bs-toggle="collapse" data-bs-target="#navbar-items"
            aria-controls="navbar-items" aria-expanded="false" aria-label="Toggle navigation">
            <span class="toggler-icon top-bar"></span>
            <span class="toggler-icon middle-bar"></span>
            <span class="toggler-icon bottom-bar"></span>
          </button>

          <!-- Navigation Menu -->

          <div id="navbar-items" class="collapse navbar-collapse">

            <ul class="navbar-nav ms-auto text-center mb-2 mb-sm-0">

              <li class="nav-item mx-auto mx-xxl-1">
                <a class="nav-link bold" href="index.html">Home</a>
              </li>

              <li class="nav-item mx-auto mx-xxl-1">
                <a class="nav-link bold" href="catering-menu.html">Menus</a>
              </li>

              <li class="nav-item mx-auto mx-xxl-1">
                <a class="nav-link bold" href="youth-training.html">Youth Training Program</a>
              </li>

              <li class="nav-item mx-auto mx-xxl-1">
                <a class="nav-link bold" href="media-events.html">Media &#38; Events</a>
              </li>

              <li class="nav-item mx-auto mx-xxl-1">
                <a class="nav-link bold" href="leadership.html">Leadership</a>
              </li>

          <!--    <li class="nav-item mx-auto mx-xxl-1">
                <a class="nav-link bold" href="gallery.html">Gallery</a>
              </li> -->

              <li class="nav-item mx-auto mx-xxl-1">
                <a class="nav-link bold" href="contact.html">Contact</a>
              </li>

              <li class="nav-item mx-auto mx-xxl-1">
                <a class="nav-link bold" href="faqs.html">FAQs</a>
              </li>

              <li class="nav-item mx-auto mx-xxl-1">
                <a class="nav-link bold" href="donate.html">Donate</a>
              </li>

              <div class="row col-2 nav-social-links ms-lg-2 text-center mx-auto">

                <div class="col-6">

                  <li class="nav-item mx-auto pt-2 pt-lg-0">
                    <a href="https://www.facebook.com/cheesesteak.jack" target="_blank">
                      <img src="facebook.svg" width="30" height="30" class="social-icon" alt="Facebook icon">
                    </a>
                  </li>

                </div>

                <div class="col-6">

                  <li class="nav-item mx-auto pt-2 pt-lg-0">
                    <a href="https://www.instagram.com/thetycoongroupalliance" target="_blank">
                      <img src="instagram.svg" width="30" height="30" class="social-icon" alt="Instagram icon">
                    </a>
                  </li>

                </div>

              </div>

            </div>

            </ul>

          </div> <!-- Navigation Menu -->

        </div> <!-- container -->

      </nav>

    </div> <!-- container -->

    `
  }
}

// ************************************************ Email Contact Form *********************************************************** //

class ContactForEvents extends HTMLElement {
  connectedCallback() {
    this.innerHTML = `

  <div class="container">

    <!-- BEGIN: Title Section -->

    <div class="row">

      <div class="col-10 mx-auto text-center">
        
        <p class="signup-title sans-serif-heading bold text-center mx-auto text-size-h0 text-white mt-3 line-height-big-squeeze">
          Get Notified About Upcoming Events &#38; Fundraisers
        </p>

      </div>

    </div>

    <!-- END: Title Section -->

    <form action="" name="asattc-event-signup">

      <div class="row col-12 col-lg-8 mx-auto">

        <div class="col-10 col-md-4 mb-3 mb-lg-0 mx-auto">
          <input class="form-control me-auto" type="text" id="firstName" name="firstName" placeholder="First Name" aria-label="Enter first name">
        </div>

        <div class="col-10 col-md-4 mb-3 mb-lg-0 mx-auto">
          <input class="form-control me-auto" type="text" id="lastName" name="lastName" placeholder="Last Name" aria-label="Enter last name">
        </div>

        <div class="col-10 col-md-4 mb-3 mb-lg-0 mx-auto">
          <input class="form-control me-auto" type="email" id="email" name="email" placeholder="Email Address" aria-label="Enter email address">
        </div>

      </div>

      <div class="col-10 col-md-2 mt-2 mt-md-4 text-center mx-auto form-input-row form-submit-button">
        <input id="submitButton" class="submit-button flyer-button bg-purple" type="submit" value="Submit" />
      </div>

      
      <!-- BEGIN: Modal -->

      <div id="emailModal" class="emailModal">

        <!-- BEGIN: Modal Content -->

        <div class="modal-content">
          
          <span class="modalClose"><strong>X</strong></span>

          <div class="text-center">
        
            <img src="asattc-logo-blue.png" class="modal-logo" alt="A Seat At The Table Cafe wordmark"/>

          </div>
            
          <p id="modal-heading" class="text-blue text-size-h2 bold text-center mx-auto mt-2 pt-0"></p>
          <p id="modal-text" class="text-blue text-size-h4 bold text-center mx-auto mt-0 pt-0 pb-2"></p>

        </div>
 
      </div>

      <!-- END: Modal -->

    </form>

  </div>

    `
  }
}

// ************************************************* Insert Footer ***************************************** //

class Footer extends HTMLElement {
  connectedCallback() {
    this.innerHTML = `

<div class="container">

  <footer class="row col-12 justify-content-center mx-auto mt-3 mb-0">

    
    <div class="row col-12 col-lg-10 px-0 px-md-2">


      <!-- BEGIN: WORDMARK & MISSION -->

      <div class="row col-12 col-xl-7 justify-content-center mx-auto px-0 px-md-2">

        <!-- BEGIN: Wordmark -->
    
        <div class="col-12 col-md-3">

          <a href="./index.html">
            <img class="footer-logo-img mx-auto mx-xl-0" height="100px" src="asattc-wordmark-location-white.svg" alt="A Seat At The Table Cafe wordmark">
          </a>

          <p class="copyright text-size-h5 text-white mt-1 mb-0">&copy; <span class="currentYear">2025</span></p>

        </div>

        <!-- END: Wordmark -->

        <!-- BEGIN: Mission -->

        <div class="col-12 col-lg-9 col-xl-9 mt-lg-1 px-0">

          <p class="mt-0 pt-0 mb-0 pb-0 text-start text-size-h5 text-white ps-0 ps-md-3">
            A Seat At The Table Cafe is a program within The Tycoon Group Alliance that offers a paid culinary training program 
            to local youth. The program provides a hands‐on opportunity for youth to explore a culinary career pathway while also receiving 
            mentorship and life skills training from seasoned professionals invested in helping them to achieve both personal and professional success.
          </p>

        </div>

        <!-- END: Mission -->

      </div> <!-- row -->

      <!-- END: WORDMARK & MISSION -->



      <!-- BEGIN: TYCONN GROUP LOGO, POLICIES, & SOCIAL LINKS -->

      <div class="row col-12 col-xl-5 justify-content-center mx-auto">

        <!-- BEGIN: Tycoon Group Logo -->

        <div class="col-12 col-md-4 col-xl-7 mt-2 mt-md-1 mb-0 justify-content-center"> 
          <img class="footer-tga-logo-img mx-auto mx-xl-0" height="50px" src="tycoon-group-alliance-logo.png" alt="The Tycoon Group Alliance logo">
        </div>

        <!-- END: Tycoon Group Logo -->

        <!-- BEGIN: Policies & Social Links -->

        <div class="col-12 col-md-3 col-xl-5 mt-2 mb-0 ">

          <ul class="nav flex-column text-lg-start">
            <li class="nav-item mb-0 mb-md-0"><a href="privacy-policy.html" class="nav-link footer-heading bold p-0 pt-md-0 text-body-secondary">Privacy Policy</a></li>
          <!-- <li class="nav-item mb-0 mb-md-0"><a href="terms-of-service.html" class="nav-link footer-heading bold p-0 pt-md-0 text-body-secondary">Terms of Service</a></li> -->
          </ul>

          <ul class="nav flex-row justify-content-center text-start col-lg-8">
            <li class="ms-sm-2 ms-md-0">
              <a href="https://www.facebook.com/cheesesteak.jack" target="_blank">
                <img src="facebook.svg" width="30" height="30" class="social-icon" alt="Facebook icon">
              </a>
            </li>

            <li class="ms-4">
              <a href="https://www.instagram.com/thetycoongroupalliance" target="_blank">
                <img src="instagram.svg" width="30" height="30" class="social-icon" alt="Instagram icon">
              </a>
            </li>
    
          </ul>

        </div>

        <!-- END: Policies & Social Links -->

      </div> <!-- row -->

      <!-- END: TYCONN GROUP LOGO, POLICIES, & SOCIAL LINKS -->

    </div>


    <!-- BEGIN: 501c(3) -->

      <!-- 501(c)3 -->
      <div class="col-12 mt-3 md-lg-0 pt-0">
        <p class="text-size-h5 text-white mb-1">The Tycoon Group Alliance is a registered 501(c)3.</p>
        <p class="text-size-h5 text-white">EIN: 92-0441959</p>
      </div>

    <!-- END: 501c(3) -->

  </footer>

</div>

    `
  }
}

// *********************** Define 'extends HTMLElements' Above *********************** //

customElements.define('first-nav', FirstNav);
customElements.define('email-contact-events', ContactForEvents);
customElements.define('footer-nav', Footer);

// *********************** Automatically Update Copyright Year *********************** //

const yearSpan = document.querySelector(".currentYear");
const currentYear = new Date();
yearSpan.innerText = currentYear.getFullYear();

// *********************** Highlight Active Links on Top Navigation *********************** //

document.querySelectorAll(".nav-link").forEach((link) => {
    if (link.href === window.location.href) {
        link.classList.add("active");
        link.setAttribute("aria-current", "page");
    }
});
